import api from '@/api/api.js'
import { carObject, reminder, newCarKind } from '@/utils/const.js'
import { Toast, Dialog } from 'vant'
import moment from 'moment'
export const vehicleMixin = {
  data() {
    return {
      vehicleInfo: {
        netWorkCode: '', // 网点code
        netWorkName: '', // 网点Nume
        // contractNo: '', // 车队协议号
        actualValue: '',
        brandName: '', // 品牌型号
        carKindCode: 'A0', // 车辆种类代码
        carKindDetailId: 'KA', // 车种明细
        loanVehicleFlag: '0', // 是否贷款车
        chgOwnerFlag: '0', // 是否过户
        engineNo: '', // 发动机号
        enrollDate: '', // 注册日期
        updateEnrollDate: '', // 注册日期调整
        issueDate: '', // 行驶证发证日期
        certificateDate: '', // 发票日期
        provinceCode: '', // 投保地区省
        cityCode: '', // 投保地区市
        licenseColorCode: '01', // 号牌底色
        licenseKindCode: '02', // 号牌种类
        licenseNo: '', // 车牌号
        noLicenseFlag: '1', // 未上牌车辆标志（0未上牌车辆；1上牌车辆；ps:上海非必传）
        oriCarKindName: 'K33', // 行驶证车辆类型
        oriModelName: '', // 厂牌车型
        platVehicleCode: '', // 行业车型编码
        purchasePrice: '', // 新车购置价
        seatCount: '', // 座位数
        tonCount: '', // 整备质量
        useNatureCode: '85', // 使用性质
        vINNo: '', // 车架号
        vehicleId: '', // 车辆ID
        makeDate: '', // 过户登记日期
        sale4SFlag: 1, // 是否4S店销售（1-是,0-否；广东（非深圳）新车必录）
        saleAreaCode: '440100', // 新车销售公司所在地市代码，广东（非深圳）新车必录
        saleAreaName: '广州市', // 新车销售公司所在地市名称
        saleCompany: '', // 新车销售公司名称，广东（非深圳）新车必录
        saleProvinceCode: '440000', // 新车销售公司所在省代码
        saleProvinceName: '广东省', // 新车销售公司所在省名称
        vehicleInfoSource: '', // 车辆信息来源
        jGTransferDate: '', // 交管过户登记日期
        newEnergyFlag: '0', // 新能源车标志 1-是 0-否
        fuelType: '', // 能源种类
        modelEnergyType: '', // 精友能源种类
        pureRange: '', // 纯电续航里程（km）
        contractNo: '', // 团车询价单号
        contractSerialNo: '' // 团车车辆编码
      },
      EnergyList: [], // 能源种类列表
      groupCarList: [], // 团车查询列表
      groupIndex: ''
    }
  },
  methods: {
    // 页面初始化清除VUEX缓存
    clearStore() {
      this.$store.commit('setIntroduceAgreementNo', '')
      this.$store.commit('setUserCode', '')
      this.$store.commit('setUserName', '')
      this.$store.commit('setTaxRelifInfo', '')
      this.$store.commit('setVehicleInfo', '')
      this.$store.commit('setCarOwnerInfo', '')
      this.$store.commit('setInsuredList', '')
      this.$store.commit('setBaseInfo', '')
      this.$store.commit('setCarShipTax', '')
      this.$store.commit('setItemkindList', '')
      this.$store.commit('setInsuredFeeList', '')
      this.$store.commit('setHandlingFeeList', '')
      this.$store.commit('setPlanList', '')
      this.$store.commit('setItemFileDataList', '')
      this.$store.commit('setEngageList', '')
      this.$store.commit('setMark', false)
      this.$store.commit('emptyAlter')
      this.$store.commit('setOrderId', '')
      this.$store.commit('setCarPolicySubInfoList', [])
    },
    inputChange() {
      this.conditions = false
    },
    newSuccessOcr(newVal) {
      this.$toast('请注意核对自动识别出的信息是否正确')
      this.vehicleInfo.engineNo = newVal.engineNo // 发动机号
      this.vehicleInfo.brandName = newVal.vehicleModelNo
      this.vehicleInfo.enrollDate = newVal.registerDate
      this.vehicleInfo.updateEnrollDate = newVal.registerDate
      this.vehicleInfo.issueDate = newVal.issueDate
      this.vehicleInfo.vINNo = newVal.vin
      this.vehicleInfo.licenseNo = newVal.plateNo
      this.vehicleInfo.certificateDate = newVal.registerDate
      this.vehicleInfo.exhaustCapacity = newVal.displacement
      this.vehicleInfo.power = newVal.power
      this.vehicleInfo.completekerbmass = newVal.curbWeight
      this.carOwnerInfo.carOwner = newVal.owner
      this.carOwnerInfo.ownerAddress = newVal.address
      if (this.shandongFlag) {
        this.queryVehicleInfoInSd(this.vehicleInfo.licenseNo, this.vehicleInfo.vINNo, this.vehicleInfo.licenseKindCode || '02')
      }
      this.previous(2)
      this.imgobjs = {
        fileId: newVal.fileId,
        fileType: '2'
      }
      this.goBack()
    },
    open() {
      // 网点编码查询
      if (this.userCode === '' && this.whethers) {
        Toast('业务归属不能为空')
        return false // 终止程序
      }
      this.switchs = true
      const data = {
        networkName: '',
        comCode: this.comCode,
        userCode: this.userCode
      }
      this.$http.post(api.garageOutlets, data)
        .then(res => {
          if (res.data.rtnCode === '0000') {
            const garageInfoLists = []
            res.data.garageInfoList.forEach((value) => {
              garageInfoLists.push({
                text: value.networkName,
                code: value.networkCode
              })
            })
            this.popupVisible = true
            this.status = 'netWork'
            this.columns = garageInfoLists
            for (const i in this.columns) {
              if (this.vehicleInfo.netWorkCode === this.columns[i].code) {
                this.columns.defaultIndex = Number(i)
              }
            }
          }
          this.switchs = false
        })
        .catch(error => {
          console.log(error)
          this.switchs = false
        })
    },
    // 确认地区选择器
    sureArea(value) {
      this.areaVisible = false
      this.province = value[0].name + ',' + value[1].name
      this.vehicleInfo.provinceCode = value[0].code
      this.vehicleInfo.cityCode = value[1].code
      this.proposalAreaCode = value[0].code
      this.proposalCityCode = value[1].code
      const param = {
        codeType: 'ProvinceCom'
      }
      for (const i in this.newCodeCodes) {
        if (i === value[1].code) {
          if (this.vehicleInfo.noLicenseFlag === '1') {
            if (this.vehicleInfo.licenseNo === '' || this.vehicleInfo.licenseNo === this.licenseNos) {
              this.vehicleInfo.licenseNo = this.newCodeCodes[i]
              this.licenseNos = this.newCodeCodes[i]
            }
          }
        }
      }
      this.$http.post(api.getByCodeType, param)
        .then(res => {
          res.data.forEach(values => {
            if (values.newCodeCode === value[0].code || values.newCodeCode === value[1].code && values.codecname !== '未知') {
              this.vehicleInfo.insuredArea = values.codeCode
              this.vehicleInfo.newCodeCode = values.newCodeCode
              if (this.vehicleInfo.newCodeCode.startsWith('440') && !this.vehicleInfo.newCodeCode.startsWith('4403')) {
                this.isNewCar = true
              } else {
                this.isNewCar = false
                this.showCar = false
              }
              this.HideType(this.vehicleInfo.insuredArea)
              this.queryVehicleType(this.vehicleInfo.insuredArea)
              if (this.$store.state.label) {
                this.$store.commit('setProposalAreaCode', values.newCodeCode)
              }
            }
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    //  山东交管车辆查询
    queryVehicleInfoInSd(licenseNo, vINNo, licenseKindCode) {
      const params = {
        licenseNo, // 车牌号
        vINNo, // 车架号
        licenseKindCode // 号牌种类-默认小型汽车号牌
      }
      // 查询规则  vINNo有  可查 vINNo没有 licenseKindCode，licenseNo必须全部有
      if (vINNo || (licenseNo && licenseKindCode)) {
        this.add += 1
        this.$http.post(api.queryVehicleInfoInSd, params).then(res => {
          if (res.data.rtnCode === '0000') {
            this.vehicleInfo.vehicleInfoSource = res.data.infoResource // 车辆信息来源 1--交管库 2--信息库
            this.vehicleInfo.engineNo = res.data.engineNo
            this.vehicleInfo.licenseNo = `鲁${res.data.licenseNo}`
            this.vehicleInfo.vINNo = res.data.vinNo
            this.vehicleInfo.enrollDate = moment(res.data.firstRegisterDate).format('YYYY-MM-DD')
            this.vehicleInfo.updateEnrollDate = moment(res.data.firstRegisterDate).format('YYYY-MM-DD')
            this.vehicleInfo.jGTransferDate = res.data.transferDate ? moment(res.data.transferDate).format('YYYY-MM-DD') : ''
            this.vehicleInfo.oriCarKindName = res.data.motorTypeCode
            this.vehicleInfo.seatCount = res.data.limitLoadPerson // 座位数
            this.vehicleInfo.exhaustCapacity = res.data.displacement // 排量
            this.vehicleInfo.tonCount = res.data.limitLoad ? res.data.limitLoad / 1000 : '0'
            this.vehicleInfo.completekerbmass = res.data.wholeWeight ? res.data.wholeWeight : '0'
            this.vehicleInfo.oriCarKindName = res.data.motorTypeCode // 车辆类型K值
            this.carOwnerInfo.carOwner = res.data.vehicleOwnerName // 车主姓名会带到信息页区分是否企业车
            this.$store.commit('setCarOwnerInfo', this.carOwnerInfo)
            this.add = this.add - 1
          } else {
            this.add = this.add - 1
            this.vehicleInfo.vehicleInfoSource = ''
          }
        }).catch(err => {
          console.log(err)
          this.add = this.add - 1
        })
      }
    },
    // 跳转车型查询
    goCarList() {
      if (this.whethers) {
        if (this.userCode === '') {
          Toast('业务归属不能为空')
          return false // 终止程序
        }
        if (this.accountType === '6') {
          if (this.introduceAgreementNo === '') {
            Toast('代理人协议号不能为空')
            return false // 终止程序
          }
        }
      }
      if (this.vehicleInfo.vINNo !== '' && this.proposalAreaCode !== '' && this.vehicleInfo.engineNo !== '' && this.vehicleInfo.enrollDate !== '' && this.vehicleInfo.brandName !== '' && this.vehicleInfo.issueDate !== '') {
        this.$router.push({
          name: 'ModelQuery',
          params: {
            vehicleInfo: this.vehicleInfo.vINNo,
            engineNum: this.vehicleInfo.engineNo,
            registData: this.vehicleInfo.enrollDate,
            issueDate: this.vehicleInfo.issueDate, // 行驶证发证日期
            brandType: this.vehicleInfo.brandName,
            cardNum: this.vehicleInfo.licenseNo,
            newCodeCode: this.proposalAreaCode, // 省
            city: this.proposalCityCode, // 市
            certificateDate: this.vehicleInfo.certificateDate,
            noLicenseFlag: this.vehicleInfo.noLicenseFlag, // 未上牌标志
            licenseKindCode: this.vehicleInfo.licenseKindCode,
            userCode: this.userCode, // 介绍人工号
            userName: this.userName, // 介绍人名字
            introduceAgreementNo: this.introduceAgreementNo // 代理人协议号
          }
        })
      } else {
        if (this.proposalAreaCode === '') {
          this.$toast('请选择服务地区')
          return false
        }
        if (this.vehicleInfo.brandName === '') {
          this.$toast('请填写品牌型号')
          return false
        }
        if (this.vehicleInfo.vINNo === '') {
          this.$toast('请填写车架号/VIN码')
          return false
        }
        if (this.vehicleInfo.engineNo === '') {
          this.$toast('请填写发动机号')
          return false
        }
        if (this.vehicleInfo.enrollDate === '') {
          this.$toast('请填写注册日期')
          return false
        }
        if (this.vehicleInfo.issueDate === '') {
          this.$toast('请填写发证日期')
          return false
        }
      }
    },
    // 渲染逻辑
    information(resultObj, index) {
      this.processing = true
      const resProvData = resultObj
      let provinceCode = ''
      let cityCode = ''
      if (resProvData.baseInfo) {
        if (resProvData.baseInfo.provinceCode) {
          this.HideType(resProvData.baseInfo.provinceCode)
        }
        this.comCode = resProvData.baseInfo.comCode || ''
        provinceCode = resProvData.baseInfo.provinceCode
        cityCode = resProvData.baseInfo.cityCode
      }
      if (localStorage.getItem('setUserString') === 'C') {
        if (provinceCode) {
          const provParam = {
            codeType: 'DisTrictCode',
            codeLevel: '2'
          }
          this.add += 1
          this.$http.post(api.getByCodeType, provParam)
            .then(res => {
              res.data.forEach(value => {
                if (value.codeCode === provinceCode) {
                  this.province = value.codecname
                  this.proposalAreaCode = provinceCode
                  this.$store.commit('setProposalAreaCode', this.proposalAreaCode)
                  if (cityCode !== '' && cityCode != null) {
                    const cityParams = {
                      codeType: 'DisTrictCode',
                      upperCode: value.codeCode,
                      codelevel: '3'
                    }
                    this.add += 1
                    this.$http.post(api.getByCodeTypeAndUpperCode, cityParams)
                      .then(resCity => {
                        this.add = this.add - 1
                        resCity.data.forEach(values => {
                          if (values.codeCode === cityCode) {
                            this.province = this.province + ',' + values.codecname
                            this.proposalCityCode = values.codeCode
                            this.$store.commit('setProposalCityCode', this.proposalCityCode)
                          }
                        })
                      })
                      .catch(error => {
                        console.log(error)
                        this.add = this.add - 1
                      })
                  }
                }
              })
              this.add = this.add - 1
            })
            .catch(error => {
              console.log(error)
              this.add = this.add - 1
            })
        }
      }
      if (resProvData.hasOwnProperty('vehicleInfo')) {
        Object.keys(resProvData.vehicleInfo).forEach(value => {
          // 输入框（续保）
          if (index === 1) {
            if (value !== 'useNatureCode' && value !== 'vINNo' && value !== 'noDamageYears' && value !== 'noLicenseFlag' && value !== 'chgOwnerFlag' && value !== 'makeDate' && value !== 'oriCarKindName') {
              this.vehicleInfo[value] = resProvData.vehicleInfo[value] || ''
            }
            this.isNewCar = false
          }
          // ocr（续保）
          if (index === 2) {
            const vehicleInfos = ['useNatureCode', 'makeDate', 'chgOwnerFlag', 'noDamageYears', 'engineNo', 'vINNo', 'enrollDate', 'issueDate', 'updateEnrollDate', 'certificateDate', 'brandName', 'licenseNo', 'noLicenseFlag', 'oriCarKindName']
            if (vehicleInfos.indexOf(value) === -1) {
              this.vehicleInfo[value] = resProvData.vehicleInfo[value] || ''
            }
            this.isNewCar = false
          }
          // （一键续保）
          if (index === 3) {
            const vehicleInfos = ['useNatureCode', 'makeDate', 'chgOwnerFlag', 'oriCarKindName', 'noDamageYears', 'noLicenseFlag']
            if (vehicleInfos.indexOf(value) === -1) {
              this.vehicleInfo[value] = resProvData.vehicleInfo[value]
            }
            this.isNewCar = false
          }
          if (index === 0) {
            if (resProvData.vehicleInfo[value] !== null && resProvData.vehicleInfo[value] !== '') {
              this.vehicleInfo[value] = resProvData.vehicleInfo[value]
            }
            if (value === 'noLicenseFlag') {
              if (this.vehicleInfo.noLicenseFlag === '1') {
                this.noCardNumActive = false
              } else if (this.vehicleInfo.noLicenseFlag === '0') {
                this.noCardNumActive = true
              }
            }
            if (value === 'saleCompany') {
              if (this.vehicleInfo.saleCompany) {
                this.isNewCar = true
                this.newCarFalt = true
              } else {
                this.isNewCar = false
              }
            }
            if (value === 'sale4SFlag') {
              this.isStore = this.vehicleInfo.sale4SFlag == 1
            }

            this.transferTime = this.vehicleInfo.makeDate
          }
          if (value === 'useNatureCode') {
            this.getNature(resProvData.vehicleInfo.useNatureCode)
          }
        })
      }
      this.add += 1
      const param = [
        { codeType: 'LicenseColor' }, // 号牌底色
        { codeType: 'LicenseKindCode' } // 号牌种类
      ]
      this.$http.post(api.getByMoreCodeType, param)
        .then(res => {
          this.add = this.add - 1
          if (res.data.rtnCode === '0000') {
            res.data.result.forEach(value => {
              if (value.codeType === 'LicenseKindCode' && value.codeCode === resProvData.vehicleInfo.licenseKindCode) {
                this.cardType = value.codecname
              }
              if (value.codeType === 'LicenseColor' && value.codeCode === resProvData.vehicleInfo.licenseColorCode) {
                this.cardColor = value.codecname
              }
            })
          }
        })
        .catch(error => {
          this.add = this.add - 1
          console.log(error)
        })
      if (resProvData.vehicleInfo.oriModelName === '' || resProvData.vehicleInfo.oriModelName === null) {
        this.vehicleInfo.oriModelName = resProvData.vehicleInfo.brandName
      }
      if (resProvData.vehicleInfo.certificateDate === '' || resProvData.vehicleInfo.certificateDate === null) {
        this.vehicleInfo.certificateDate = resProvData.vehicleInfo.enrollDate
      }
      if (resProvData.baseInfo) {
        if (resProvData.baseInfo.introduceAgreementNo && resProvData.baseInfo.introduceAgreementNo !== '') {
          this.agreementNoList = resProvData.baseInfo.introduceAgreementNo
          this.$store.commit('setIntroduceAgreementNo', this.introduceAgreementNo)
        }
        if (resProvData.baseInfo.introduceCode && resProvData.baseInfo.introduceCode !== '') {
          this.userCode = resProvData.baseInfo.introduceCode
          console.log(this.userCode, 'userCode======》')
          this.whethers = true
          this.$store.commit('setUserCode', this.userCode)
        }
        if (resProvData.baseInfo.introduceName && resProvData.baseInfo.introduceName !== '') {
          this.userName = resProvData.baseInfo.introduceName
          this.whethers = true
          this.$store.commit('setUserName', this.userName)
        }
      }
      const syxClassId = resProvData.vehicleInfo.carKindCode
      if (syxClassId === 'H0' || syxClassId === 'H1') {
        this.syxClassId = true
      }
      this.vehicleInfo.vehicleId = resProvData.vehicleInfo.vehicleId
      for (const i in carObject) {
        if (resProvData.vehicleInfo[i] === '' || resProvData.vehicleInfo[i] === null || resProvData.vehicleInfo[i] === undefined) {
          this.vehicleInfo[i] = carObject[i]
        }
      }
      this.getVehicletype(resProvData.vehicleInfo.oriCarKindName)
      if (!this.$store.state.label) {
        if (resProvData.taxRelifInfo) {
          this.$store.commit('setTaxRelifInfo', resProvData.taxRelifInfo)
        }
        if (resProvData.vehicleInfo) {
          this.$store.commit('setVehicleInfo', resProvData.vehicleInfo)
        }
        if (resProvData.carOwnerInfo) {
          this.$store.commit('setCarOwnerInfo', resProvData.carOwnerInfo)
        }
        if (resProvData.insuredList) {
          this.$store.commit('setInsuredList', resProvData.insuredList)
        }
        if (resProvData.baseInfo) {
          this.$store.commit('setBaseInfo', resProvData.baseInfo)
        }
        if (resProvData.carShipTax) {
          this.$store.commit('setCarShipTax', resProvData.carShipTax)
        }
        if (resProvData.itemkindList) {
          this.$store.commit('setItemkindList', resProvData.itemkindList)
        }
        if (resProvData.insuredFeeList) {
          this.$store.commit('setInsuredFeeList', resProvData.insuredFeeList)
        }
        if (resProvData.handlingFeeList) {
          this.$store.commit('setHandlingFeeList', resProvData.handlingFeeList)
        }
        if (resProvData.planList) {
          this.$store.commit('setPlanList', resProvData.planList)
        }
        if (resProvData.carPolicySubInfoList && resProvData.carPolicySubInfoList.length > 0) {
          this.$store.commit('setCarPolicySubInfoList', resProvData.carPolicySubInfoList)
        }
        if (resProvData.attachRiskList && resProvData.attachRiskList.length > 0) {
          this.$store.commit('set_attachRiskList', resProvData.attachRiskList)
        }
        if (resProvData.itemFileDataList) {
          this.$store.commit('setItemFileDataList', resProvData.itemFileDataList)
          if (resProvData.itemFileDataList !== null) {
            this.itemFileDataList = resProvData.itemFileDataList
          }
        }
        if (resProvData.engageList && index === 0) {
          this.$store.commit('setEngageList', resProvData.engageList)
        }
        index === 0 ? this.$store.commit('setEntrance', 0) : this.$store.commit('setEntrance', 1)
        if (resProvData.engageList && resProvData.engageList.length > 0 && index === 0) {
          this.$store.commit('setEngageLists', true)
        }
      }
      if (this.conditions) {
        if (resultObj.itemkindList.length > 0 && resultObj.itemkindList[0].kindCode !== '') {
          let JQtype = false
          let SYtype = false
          resultObj.itemkindList.forEach(value => {
            value.kindCode === 'BZ' ? JQtype = true : SYtype = true
          })
          if (JQtype === true && SYtype === true) {
            this.$store.commit('setCalculateFlag', '0')
          }
          if (JQtype === false && SYtype === true) {
            this.$store.commit('setCalculateFlag', '1')
          }
          if (JQtype === true && SYtype === false) {
            this.$store.commit('setCalculateFlag', '2')
          }
        }
        if (resultObj.vehicleInfo.seatCount === '' || resultObj.vehicleInfo.seatCount === null) {
          this.$store.commit('setSteps', '1')
          return ''
        }
        if (resultObj.itemkindList[0].kindCode === '' || resultObj.itemkindList.length === 0) {
          this.$store.commit('setSteps', '2')
          return ''
        }
        if (resultObj.engageList.length === 0 || resultObj.engageList[0].clauseCode === '') {
          this.$store.commit('setSteps', '3')
          return ''
        }
        this.$store.commit('setSteps', '4')
      }
    },
    async goNext() {
      if (this.conditions) {
        if (this.vehicleInfo.seatCount === '0' || this.vehicleInfo.seatCount === 0) {
          Toast('座位不能小于0')
          return false
        }
        if (this.syxClassId) {
          if (this.vehicleInfo.useNatureCode === '83' || this.vehicleInfo.useNatureCode === '84') {
            Toast('车辆类型与车辆使用性质不符合条件')
            return false
          }
        }
        if (this.proposalAreaCode === '' || this.proposalAreaCode === null || this.proposalAreaCode === undefined) {
          Toast('服务地区不能为空')
          return false // 终止程序
        }
        // 判断用户信息是否为空 如果为空提示用户填写信息
        if (this.vehicleInfo.noLicenseFlag === '0') {
          for (var key in reminder) {
            if (key !== 'licenseNo') {
              if (this.vehicleInfo[key] === '' || this.vehicleInfo[key] === null || this.vehicleInfo[key] === undefined) {
                Toast(reminder[key] + '不能为空')
                return false // 终止程序
              }
            }
          }
        } else {
          for (var keys in reminder) {
            if (this.vehicleInfo[keys] === '' || this.vehicleInfo[keys] === null || this.vehicleInfo[keys] === undefined) {
              Toast(reminder[keys] + '不能为空')
              return false // 终止程序
            }
          }
        }
        if (this.guangdongArea) {
          if (!this.salesPerson) {
            this.$toast('销售人员不能为空')
            return false
          }
          if (!this.professionalNum) {
            this.$toast('执业证编号不能为空')
            return false
          }
          this.$store.commit('setBaseInfo', {
            salesPerson: this.salesPerson,
            professionalNum: this.professionalNum
          })
          console.log(this.$store.state.baseInfo, '======')
        }
        if (this.isNewCar && this.newCarFalt) {
          for (var item in newCarKind) {
            if (this.vehicleInfo[item] === '' || this.vehicleInfo[item] === null || this.vehicleInfo[item] === undefined) {
              Toast(newCarKind[item] + '不能为空')
              return false // 终止程序
            }
          }
          if (this.vehicleInfo.saleCompany.length < 7) {
            this.$toast('新车销售公司名称不能少于七个字')
            return false
          }
        }
        const add = /^[0-9a-zA-Z]+$/
        for (var i = 0; i < this.vehicleInfo.vINNo.length; i++) {
          if (!add.test(this.vehicleInfo.vINNo[i])) {
            Toast('车架号只能是字母或数字')
            return false
          }
        }
        if (this.vehicleInfo.chgOwnerFlag === '1') {
          if (this.vehicleInfo.makeDate === '') {
            Toast('请输入过户日期')
            return false
          }
        }
        const useNat = /^[H]/
        if ((this.vehicleInfo.carKindCode === 'H0' || this.vehicleInfo.carKindCode === 'H1') && (this.vehicleInfo.useNatureCode === '85')) {
          Toast('货车不能选择家庭自用')
          return false
        }
        if (useNat.test(this.vehicleInfo.oriCarKindName) && this.vehicleInfo.useNatureCode === '85') {
          Toast('货车不能选择家庭自用')
          return false
        }
        if ((this.vehicleInfo.carKindCode === 'H0' || this.vehicleInfo.carKindCode === 'H1') && (this.vehicleInfo.useNatureCode === '9A' || this.vehicleInfo.useNatureCode === '9B' || this.vehicleInfo.useNatureCode === '9C')) {
          Toast('货车不能选择 营业出租、租赁、城市公交、公路客运!')
          return false
        }
        if (this.vehicleInfo.carKindCode === 'A0' && (this.vehicleInfo.useNatureCode === '9D' || this.vehicleInfo.useNatureCode === '82')) {
          Toast('客车不能选择货运')
          return false
        }
        this.vehicleInfo.printModelName = this.vehicleInfo.brandName
        this.$store.commit('setVehicleInfo', this.vehicleInfo)
        this.$store.commit('setProvince', this.vehicleInfo.provinceCode)
        this.$store.commit('setProposalAreaCode', this.proposalAreaCode)
        this.$store.commit('setProposalCityCode', this.proposalCityCode)
        this.$store.commit('setUserCode', this.userCode)
        this.$store.commit('setUserName', this.userName)
        this.$store.commit('setIntroduceAgreementNo', this.introduceAgreementNo)
        if (this.imgobjs.fileId !== '') {
          const imageInfoLists = []
          if (this.$store.state.itemFileDataList.length > 0 && this.$store.state.itemFileDataList[0].fileList.length > 0 && this.$store.state.itemFileDataList[0].fileList[0].fileId !== '') {
            this.$store.state.itemFileDataList[0].fileList.forEach(value => {
              imageInfoLists.push({
                fileId: value.fileId,
                fileType: value.fileType
              })
            })
          }
          imageInfoLists.push(this.imgobjs)
          const JQfile = {
            businessNo: 10501237000019000000,
            riskCode: localStorage.getItem('whetherFeeChangeArea') === '1' ? '050A' : '0501'
          }
          const data = {
            orderId: this.$store.state.orderId,
            terminalId: localStorage.getItem('setTerminalId'),
            orderOrigin: localStorage.getItem('setChannelCode'),
            channelCode: localStorage.getItem('setChannelCode'),
            itemFileDataList: []
          }
          if (this.guangdongArea) {
            data.baseInfo = {}
            data.baseInfo.salesPerson = this.salesPerson
            data.baseInfo.professionalNum = this.professionalNum
          }
          if (imageInfoLists.length !== 0) {
            JQfile.fileList = imageInfoLists
            data.itemFileDataList.push(JQfile)
          }
          this.add += 1
          this.$http.post(api.save, data)
            .then(res => {
              if (res.data.rtnCode === '0000') {
                this.$store.commit('setItemFileDataList', res.data.resultObj.itemFileDataList)
                this.imgobjs = {
                  fileId: '',
                  fileType: ''
                }
                this.$store.commit('setStep', '2')
              }
              this.add = this.add - 1
            })
            .catch(error => {
              console.log(error)
              this.add = this.add - 1
            })
        } else {
          console.log(this.$store.state.vehicleInfos, '车辆信息')
          this.$store.commit('setStep', '2')
        }
      } else {
        this.$toast('请先点击查看厂牌车型')
      }
    },
    searchGroupCar() {
      // if (this.userCode === '' && this.whethers) {
      //   Toast('业务归属不能为空')
      //   return false // 终止程序
      // }
      // if (this.userComCode === '' && this.whethers) {
      //   Toast('业务归属不能为空')
      //   return false // 终止程序
      // }

      if (this.whethers) {
        if (this.userCode === '' || this.userComCode === '') {
          Toast('业务归属不能为空')
          return false // 终止程序
        }
        if (this.accountType === '6') {
          if (this.introduceAgreementNo === '') {
            Toast('代理人协议号不能为空')
            return false // 终止程序
          }
        }
        this.isSearchGroupCar = true
      }else {
        this.isSearchGroupCar = true
      }
      
    },
    queryCarList() {
      this.switchs = true
      const params = {
        companyCode: this.singlePointComeCode || this.userComCode,
        handlerCode: this.userCode,
        inquiryProjectsName: '',
        projectsCode: ''
      }
      const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
      if (reg.test(this.searchValue)) {
        params.inquiryProjectsName = this.searchValue
      } else {
        params.projectsCode = this.searchValue
      }
      this.$http.post(api.queryList, params).then(Qres => {
        if (Qres.data.rtnCode === '0000') {
        //   Qres.data.inquiryPolicyQueryResDtoList = [{
        //     agentCode:'U200002000447',
        //     id:1,
        //     projectsCode:'123you',
        //     inquiryProjectsName:'D',
        //     serialno:1,
        //     useNatureName: "家庭自用",
        //     carKindName: "客车",
        //     isSingleThirdName:'是'
        //   },
        //   {
        //     agentCode:'222',
        //     id:2,
        //     projectsCode:'345',
        //     inquiryProjectsName:'B',
        //     serialno:2,
        //     useNatureName: "家庭自用",
        //     carKindName: "客车",
        //     isSingleThirdName:'是'
        //   },
        //   {
        //     agentCode:'333',
        //     id:3,
        //     projectsCode:'456',
        //     inquiryProjectsName:'D',
        //     serialno:3,
        //     useNatureName: "家庭自用",
        //     carKindName: "客车",
        //     isSingleThirdName:'是'
        //   },
        //   {
        //     agentCode:'U200002000447',
        //     id:4,
        //     projectsCode:'567you',
        //     inquiryProjectsName:'D',
        //     serialno:4,
        //     useNatureName: "家庭自用",
        //     carKindName: "客车",
        //     isSingleThirdName:'是'
        //   }
        // ]
        let groupList = []
        const introduceAgreementNo = this.introduceAgreementNo.split('-')[0]
          if (Qres.data.inquiryPolicyQueryResDtoList && Qres.data.inquiryPolicyQueryResDtoList.length > 0) {
            Qres.data.inquiryPolicyQueryResDtoList.forEach(res => {
              res.active = false
              if (this.searchValue === res.projectsCode) {
                groupList.push(res)
              } 
              if (this.searchValue === res.inquiryProjectsName) {
                groupList.push(res)
                groupList = this.checkSort(groupList,introduceAgreementNo)
              }
            })
            this.groupCarList = groupList
          }
          this.switchs = false
        } else {
          this.$toast(Qres.data.rtnMsg)
          this.switchs = false
        }
      }).catch(err => {
        console.log(err)
        this.switchs = false
      })
    },
    checkGroup(item, groupIndex) {
      item.active = !item.active
      this.groupCarList.forEach((el, index) => {
        if (el.active && index !== groupIndex) {
          el.active = false
        }
      })
      this.groupIndex = item.active ? groupIndex : ''
      console.log(this.groupIndex)
    },
    checkSort(data, cods){
      let resultArr = []
      data.forEach(item => {
        if (cods === item.agentCode) {
            resultArr.unshift(item)
        } else {
            resultArr.push(item)
        }
      })
      return resultArr
     
    },
    groupSure() {
      const introduceAgreementNo = this.introduceAgreementNo.split('-')[0]
      if (this.groupIndex !== '') {
        this.vehicleInfo.contractNo = this.groupCarList[this.groupIndex].projectsCode
        this.vehicleInfo.contractSerialNo = this.groupCarList[this.groupIndex].carCode
        this.vehicleInfo.carKindCode = this.groupCarList[this.groupIndex].carKindCode
        this.vehicleInfo.useNatureCode = this.groupCarList[this.groupIndex].useNatureCode
        this.oriCarKindName = this.groupCarList[this.groupIndex].carKindName
        this.useMethod = this.groupCarList[this.groupIndex].useNatureName
        this.agentCode = this.groupCarList[this.groupIndex].agentCode
        this.groupCarList = []
        this.groupIndex = ''
        this.searchValue = ''
        if (introduceAgreementNo) {
          if (this.agentCode !== introduceAgreementNo) {
            Dialog.alert({
              title: '标题',
              confirmButtonColor:'rgba(94, 37, 137, 1)',
              message: `该协议${this.vehicleInfo.contractNo}已绑定在个人代理渠道<span style="color:rgba(94, 37, 137, 1);font-weight: bold;font-size:.16rem">${this.agentCode}</span>下，可选择该渠道账单出单，或选择其他团客协议。如需更换协议归属，请联系机构同时在团车系统维护`,
            }).then(() => {
            });
          } 
        }
      }
      this.isSearchGroupCar = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/car/vehicle/Mixin/mixin.js